import { Alert, Typography } from "@mui/material";

const tTitle = "Event times pending approval";
const tDescription =
  "These times are not visible to the public until approved. Open Upcoming Event Times to review and approve them.";

export interface EventPendingTimesPanelProps {
  pendingCount: number;
}

export function EventPendingTimesPanel({ pendingCount }: EventPendingTimesPanelProps) {
  if (pendingCount === 0) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <Typography fontWeight={600} variant="subtitle1">
        {tTitle} ({pendingCount})
      </Typography>
      <Typography variant="body2">{tDescription}</Typography>
    </Alert>
  );
}
